export const EMAIL_NOT_VERIFIED = 'EMAIL_NOT_VERIFIED';
// The backend allows one resend per 60 s; start the same cooldown locally after a successful send.
export const RESEND_COOLDOWN_SECONDS = 60;

interface ErrorLike {
  response?: {
    status?: number;
    data?: unknown;
    headers?: Record<string, unknown>;
  };
}

function problemBody(e: unknown): Record<string, unknown> {
  const data = (e as ErrorLike | null)?.response?.data;
  if (!data || typeof data !== 'object') return {};
  const body = data as Record<string, unknown>;
  // Spring may nest extension members under `properties`.
  const properties = body.properties;
  return properties && typeof properties === 'object'
    ? { ...(properties as Record<string, unknown>), ...body }
    : body;
}

export function problemCode(e: unknown): string | undefined {
  const code = problemBody(e).code;
  return typeof code === 'string' ? code : undefined;
}

export function isEmailNotVerified(e: unknown): boolean {
  return (e as ErrorLike | null)?.response?.status === 403 && problemCode(e) === EMAIL_NOT_VERIFIED;
}

export function retryAfterSeconds(e: unknown): number | null {
  const fromBody = Number(problemBody(e).retryAfterSeconds);
  if (Number.isFinite(fromBody) && fromBody > 0) return Math.ceil(fromBody);
  const header = (e as ErrorLike | null)?.response?.headers?.['retry-after'];
  const fromHeader = Number(header);
  return Number.isFinite(fromHeader) && fromHeader > 0 ? Math.ceil(fromHeader) : null;
}
